import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Wrench = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 20 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        d="M17.4845 6.14586C17.473 6.01233 17.175 5.7559 17.0488 5.71016C16.9224 5.66414 16.7809 5.69547 16.6857 5.79007L14.7777 7.69807L12.2995 5.21978L14.2456 3.28093C14.3409 3.18614 14.3719 3.04511 14.3261 2.91937C14.2797 2.79338 13.9742 2.52646 13.8398 2.51489C12.6579 2.41344 11.4998 2.83384 10.6625 3.66812C9.51576 4.81065 9.21208 6.47907 9.74984 7.90119C9.69106 7.95052 9.63307 8.0028 9.57586 8.05916L3.07953 14.1661C3.07724 14.1683 3.07498 14.1707 3.0725 14.1729C2.30851 14.9341 2.30851 16.1725 3.0725 16.9338C3.83662 17.6949 5.07065 17.6856 5.83451 16.9245C5.83781 16.9214 5.84082 16.9184 5.84383 16.9149L11.9204 10.3927C11.9758 10.3373 12.0272 10.2793 12.0757 10.2197C13.5036 10.7564 15.1793 10.4546 16.3271 9.31134C17.1642 8.477 17.5865 7.32319 17.4845 6.14586Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  )
})

export default Wrench
